import React, { useState, useRef } from 'react';
import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    TextField,
    Button,
    Paper,
    Typography,
    Alert,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Container,
    Chip,
    Divider,
    Card,
    CardContent,
    CardHeader
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Save as SaveIcon, Clear as ClearIcon, Send as SendIcon, Assignment as AssignmentIcon, Create as SignatureIcon } from '@mui/icons-material';
import SignatureCanvas from "react-signature-canvas";
import swal from 'sweetalert';
import PDFPreviewDialog from './PDFPreviewDialog';
import { generatePDF } from './calidadPDFen';

// Generador de UUID alternativo si crypto.randomUUID no está disponible
function generateUUID() {
    if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    // fallback simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// --- Styled Components (Premium Glassmorphism) ---

const GlassContainer = styled(Paper)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.18)',
}));

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '16px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginBottom: theme.spacing(4),
    border: '1px solid rgba(0,0,0,0.05)'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: '#34495e',
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '1.2rem',
    borderBottom: '2px solid #3f51b5',
    display: 'inline-block',
    paddingBottom: '4px'
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#f8f9fa',
    color: '#2d3436',
    fontWeight: 700,
    borderBottom: '2px solid #e9ecef',
    textTransform: 'uppercase',
    fontSize: '0.85rem',
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
    fontSize: '0.9rem',
    borderBottom: '1px solid #f1f3f5',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '50px',
    padding: '10px 24px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 20px 0 rgba(0,0,0,0.15)',
    },
}));

export default function EvaluationCalidaden() {


    const [loading, setLoading] = useState(false);
    const [codigoInternoProveedor, setCodigoInternoProveedor] = useState(localStorage.Proveedor);
    const [nombreProveedor, setNombreProveedor] = useState(localStorage.Tproveedor);
    const [tipoDocumento, setTipoDocumento] = useState('NIT');
    const [numeroDocumento, setNumeroDocumento] = useState(localStorage.Nit);
    const [direccion, setDireccion] = useState(localStorage.Direcc);
    const [prestadorBienesServicios, setPrestadorBienesServicios] = useState('');
    const [evaluador, setEvaluador] = useState('');
    const [cargo, setCargo] = useState('');
    const [categoria, setCategoria] = useState(localStorage.Categoria);
    const [fechaEvaluacion, setFechaEvaluacion] = useState('');
    const [periodoEvaluado, setPeriodoEvaluado] = useState('');
    const [correoProveedor, setCorreoProveedor] = useState(localStorage.Email);
    const sigPad = useRef({});
    const sigPad2 = useRef({});
    const [firmaFile, setFirmaFile] = useState(null); // Puede ser base64 o URL
    const [firmaFile2, setFirmaFile2] = useState(null);
    const [firmaFileLoading, setFirmaFileLoading] = useState(false);
    const [firmaFileError, setFirmaFileError] = useState(null);
    const [observacion, setObservacion] = useState('');
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfBase64, setPdfBase64] = useState('');
    const [showPdfPreview, setShowPdfPreview] = useState(false);

    const [responsableVisita, setResponsableVisita] = useState('');
    const [responsableRecibir, setResponsableRecibir] = useState('');

    const handleCodigoInternoProveedorChange = (event) => {
        setCodigoInternoProveedor(event.target.value);
    };

    const handleNombreProveedorChange = (event) => {
        setNombreProveedor(event.target.value);
    };

    const handleTipoDocumentoChange = (event) => {
        setTipoDocumento(event.target.value);
    };

    const handleNumeroDocumentoChange = (event) => {
        setNumeroDocumento(event.target.value);
    };

    const handleDireccionChange = (event) => {
        setDireccion(event.target.value);
    };

    const handlePrestadorBienesServiciosChange = (event) => {
        setPrestadorBienesServicios(event.target.value);
    };

    const handleEvaluadorChange = (event) => {
        setEvaluador(event.target.value);
    };

    const handleCargoChange = (event) => {
        setCargo(event.target.value);
    };

    const handleCategoriaChange = (event) => {
        setCategoria(event.target.value);
    };

    const handleFechaEvaluacionChange = (event) => {
        setFechaEvaluacion(event.target.value);
    };

    const handlePeriodoEvaluadoChange = (event) => {
        setPeriodoEvaluado(event.target.value);
    };

    const handleCorreoProveedorChange = (event) => {
        setCorreoProveedor(event.target.value);
    };

    const handleObservacionChange = (event) => {
        setObservacion(event.target.value);
    };



    const evaluationData = [
        {
            "category": "QUALITY OF GOODS AND/OR SERVICES",
            "questions": [
                {
                    "question": "Does it meet the purchase order objective?",
                    "index": 0
                },
                {
                    "question": "Does the quality of the specifications of the good, product, or service meet the requirements?",
                    "index": 1
                },
                {
                    "question": "100% compliance in delivering the required quantities? ",
                    "index": 2
                },
                {
                    "question": "Response time to warranties and claims?",
                    "index": 3
                },
                {
                    "question": "Index of claims and rejections?",
                    "index": 4
                }
            ]
        },
        {
            "category": "COMMERCIAL",
            "questions": [
                {
                    "question": "Payment method? Cash = 1 16-30 days = 2 31 days and beyond = 3",
                    "index": 5
                },
                {
                    "question": "Competitiveness in total acquisition cost (prices, added value, deliveries, freight, repurchases, additional shipping costs, etc.)?",
                    "index": 6
                },
                {
                    "question": "Supplier flexibility? (Minimum orders/Handling emergencies)",
                    "index": 7
                },
                {
                    "question": "Innovation (Proposals for improvement in competitiveness, technological updates, connectivity, proactive delivery tracking)",
                    "index": 8
                }
            ]
        },
        {
            "category": "RESPONSE TIMELINESS TO REQUIREMENTS",
            "questions": [
                {
                    "question": "Does the supplier provide timely responses to quotes, proformas, inquiries, advice, and/or general consultations?",
                    "index": 9
                }
            ]
        },
        {
            "category": "ON-TIME ORDER DELIVERY COMPLIANCE",
            "questions": [
                {
                    "question": "What is the compliance level with delivery deadlines?",
                    "index": 10
                }
            ]
        },
        {
            "category": "ENVIRONMENTAL",
            "questions": [
                {
                    "question": "Does the company have an environmental management plan?",
                    "index": 11
                },
                {
                    "question": "Does the company demonstrate the use of measures to reduce negative environmental impacts, such as carbon footprint measurement, water footprint, recycling, reuse, material packaging and packaging take-back, and effluent control? Does it have environmental certifications? (Rating: 3 if it meets all mentioned aspects, rating: 2 if it partially meets, rating: 1 if it does not meet)",
                    "index": 12
                }
            ]
        },
        {
            "category": "PSYCHOSOCIAL",
            "questions": [
                {
                    "question": "Does the company have plans for the management and control of psychosocial risks, occupational risks, safety, and health at work? (Rating: 3 if it has complete plans, rating: 2 if it has partial plans, rating: 1 if it does not have plans)",
                    "index": 13
                },
                {
                    "question": "Are volunteer activities, social works, and support for foundations encouraged?",
                    "index": 14
                },
                {
                    "question": "What benefits are granted to collaborators? (Fair wages, educational, economic, social incentives, among others)",
                    "index": 15
                }
            ]
        },
        {
            "category": "RELIABLE BUSINESS",
            "questions": [
                {
                    "question": "Does the company have a code of ethics and conduct that applies to employees, suppliers, shareholders, and others? (Rating: 3 if it has a complete code, rating: 2 if it has a partial code, rating: 1 if it does not have a code)",
                    "index": 16
                }
            ]
        },
        {
            "category": "SUPPLIER DOCUMENTATION",
            "questions": [
                {
                    "question": "Does the company comply with TALSA's internal purchasing policies and provide the required documentation for supplier selection, evaluation, and monitoring? (Rating: 3 if documents are complete, rating: 2 if documents are incomplete, rating: 1 if documentation is not provided)",
                    "index": 17
                }
            ]
        },
        {
            "category": "AFTER-SALES SERVICES",
            "questions": [
                {
                    "question": "Does the company meet the service level promises, such as support, warranties, product or service replacement, and provide advice and training? (Rating: 3 if it meets all promises, rating: 2 if it partially meets, rating: 1 if it does not meet)",
                    "index": 18
                },
                {
                    "question": "Does the company demonstrate proactivity and perform timely follow-up on deliveries and service coverage nationwide, including TALSA locations? (Rating: 3 if proactive and performs timely follow-up, rating: 2 if partially proactive, rating: 1 if not proactive and does not perform timely follow-up)",
                    "index": 19
                }
            ]
        }];



    const asociados = [
        { tipo: 'FAVORABLE', puntaje: '> 80', accion: 'Highlight strengths to reinforce the current position and noteworthy aspects demonstrating good performance.', control: 'No verification required' },
        {
            tipo: 'CONDITIONALLY FAVORABLE', puntaje: '> 60 and <= 80', accion: 'Identify areas for improvement to implement corrective actions that demonstrate overcoming these weaknesses. A new evaluation will be scheduled within a maximum period of 6 months.',
            control: 'An occasional check will be conducted after three months to assess the performance and compliance of the supplier.'
        },
        {
            tipo: 'UNFAVORABLE', puntaje: '> 0 and <= 60', accion: 'Inform the supplier that they have not met the expected parameters to maintain the continuity of their services. This evaluation is considered UNFAVORABLE.',
            control: 'Study the action plans submitted by the supplier.'
        },
    ];


    const [evaluations, setEvaluations] = useState(Array(20).fill(0));

    const handleEvaluationChange = (index, value) => {
        setEvaluations((prevEvaluations) => {
            const newEvaluations = [...prevEvaluations];
            newEvaluations[index] = value;
            return newEvaluations;
        });
    };

    const [totalPoints, setTotalPoints] = useState(0);

    const sumPoints = () => {
        const sum = evaluations.reduce((total, evaluation) => total + evaluation, 0);
        setTotalPoints(sum);
    };

    return (
        <GlassContainer elevation={3}>
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e' }}>
                    SUPPLIER QUALITY EVALUATION
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Quality Management
                </Typography>
            </Box>

            {/* Module 1: General Information */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>General Information</SectionTitle>}
                    avatar={<AssignmentIcon color="primary" />}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="INTERNAL SUPPLIER CODE"
                                fullWidth
                                required
                                value={codigoInternoProveedor}
                                onChange={handleCodigoInternoProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="SUPPLIER NAME"
                                fullWidth
                                required
                                value={nombreProveedor}
                                onChange={handleNombreProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label="DOCUMENT TYPE"
                                    required
                                    value={tipoDocumento}
                                    onChange={handleTipoDocumentoChange}
                                >
                                    <MenuItem value="NIT">NIT</MenuItem>
                                    <MenuItem value="CEDULA">CEDULA</MenuItem>
                                    <MenuItem value="RUT">RUT</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                label="DOCUMENT NUMBER"
                                fullWidth
                                required
                                value={numeroDocumento}
                                onChange={handleNumeroDocumentoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="ADDRESS"
                                fullWidth
                                required
                                value={direccion}
                                onChange={handleDireccionChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="GOODS OR SERVICES PROVIDER"
                                fullWidth
                                required
                                value={prestadorBienesServicios}
                                onChange={handlePrestadorBienesServiciosChange}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                label="EVALUATOR"
                                fullWidth
                                required
                                value={evaluador}
                                onChange={handleEvaluadorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="JOB TITLE"
                                fullWidth
                                required
                                value={cargo}
                                onChange={handleCargoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="CATEGORY"
                                fullWidth
                                required
                                value={categoria}
                                onChange={handleCategoriaChange}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                label="EVALUATION DATE"
                                type="date"
                                fullWidth
                                required
                                value={fechaEvaluacion}
                                onChange={handleFechaEvaluacionChange}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="EVALUATED PERIOD"
                                fullWidth
                                required
                                value={periodoEvaluado}
                                onChange={handlePeriodoEvaluadoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="SUPPLIER EMAIL"
                                fullWidth
                                value={correoProveedor}
                                onChange={handleCorreoProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
            <TableContainer component={Paper} elevation={0} sx={{ mb: 4, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead colSpan={2} align="center">PUNCTUATION SYSTEM</StyledTableCellHead>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellHead align="center" width="20%">Score</StyledTableCellHead>
                            <StyledTableCellHead align="center">Category</StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <StyledTableCellBody align="center">1</StyledTableCellBody>
                            <StyledTableCellBody align="center">Fails</StyledTableCellBody>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellBody align="center">2</StyledTableCellBody>
                            <StyledTableCellBody align="center">Partially compliant</StyledTableCellBody>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellBody align="center">3</StyledTableCellBody>
                            <StyledTableCellBody align="center">Compliant</StyledTableCellBody>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer component={Paper} elevation={0} sx={{ maxHeight: "600px", maxWidth: "100%", overflowY: "auto", border: '1px solid #e0e0e0', borderRadius: 2, mb: 4 }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead>Category</StyledTableCellHead>
                            <StyledTableCellHead>Questions</StyledTableCellHead>
                            <StyledTableCellHead align="center">Assessment</StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {evaluationData.map((category, categoryIndex) => (
                            <React.Fragment key={categoryIndex}>
                                {category.questions.map((question, questionIndex) => (
                                    <TableRow key={`${categoryIndex}-${questionIndex}`}>
                                        {questionIndex === 0 && (
                                            <StyledTableCellBody
                                                sx={{ fontWeight: 'bold', backgroundColor: '#fafafa', borderRight: '1px solid #eee' }}
                                                rowSpan={category.questions.length}
                                            >
                                                {category.category}
                                            </StyledTableCellBody>
                                        )}
                                        <StyledTableCellBody sx={{ width: '50%' }}>
                                            {question.question}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody align="center">
                                            <Select
                                                value={evaluations[question.index] || ''}
                                                onChange={(event) => handleEvaluationChange(question.index, event.target.value)}
                                                sx={{ minWidth: 120, height: 40 }}
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled>Select...</MenuItem>
                                                <MenuItem value={1}>1 (Fails)</MenuItem>
                                                <MenuItem value={2}>2 (Partial)</MenuItem>
                                                <MenuItem value={3}>3 (Compliant)</MenuItem>
                                            </Select>
                                        </StyledTableCellBody>
                                    </TableRow>
                                ))}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>



            {/* Observations */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom color="textSecondary">General Comments</Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={observacion}
                    onChange={handleObservacionChange}
                    variant="outlined"
                    placeholder="Enter general observations about the evaluation..."
                />
            </Box>


            {/* Result Tables */}
            {/* Module 2: Evaluation Results */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>Evaluation Results</SectionTitle>}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Typography style={{ fontWeight: "bold", color: "red", marginBottom: '16px' }}>
                        Note: All items with comments must have an action plan, which must be documented within the next three (3) months.
                    </Typography>
                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellHead>Qualification</StyledTableCellHead>
                                    <StyledTableCellHead>Score</StyledTableCellHead>
                                    <StyledTableCellHead>Action to follow</StyledTableCellHead>
                                    <StyledTableCellHead>Control</StyledTableCellHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {asociados.map((asociado, index) => (
                                    <TableRow key={index} hover>
                                        <StyledTableCellBody sx={{ fontWeight: 'bold' }}>{asociado.tipo}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.puntaje}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.accion}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.control}</StyledTableCellBody>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="h6" color="success.dark" gutterBottom>
                            FINAL SCORE: <strong>{((totalPoints / (evaluations.length * 3)) * 100).toFixed(2)} %</strong>
                        </Typography>
                        <Chip
                            label={
                                (((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 80 ? "FAVORABLE" : ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 60
                                    && ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) <= 80 ? "CONDITIONALLY FAVORABLE" : "UNFAVORABLE")
                            }
                            color={
                                (((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 80 ? "success" : ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 60
                                    && ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) <= 80 ? "warning" : "error")
                            }
                            sx={{ fontWeight: 'bold', fontSize: '1rem', px: 2 }}
                        />
                    </Box>
                </CardContent>
            </StyledCard>


            {/* Module 3: Signatures */}
            <StyledCard elevation={0} sx={{ border: '1px solid #bbdefb' }}>
                <CardHeader
                    title={<SectionTitle>Signatures & Approval</SectionTitle>}
                    avatar={<SignatureIcon color="primary" />}
                />
                <CardContent>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={8}>
                            <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                                    RESPONSIBLE FOR EXECUTING EVALUATION
                                </Typography>
                                <TextField
                                    label="Evaluators Name"
                                    fullWidth
                                    variant="standard"
                                    sx={{ mb: 3, maxWidth: 400 }}
                                    value={responsableVisita}
                                    onChange={(e) => setResponsableVisita(e.target.value)}
                                />
                                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
                                    <SignatureCanvas
                                        canvasProps={{
                                            width: 500,
                                            height: 180,
                                            className: 'sigCanvas',
                                        }}
                                        ref={sigPad}
                                    />
                                </Box>
                                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                                    <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad.current.clear(); setFirmaFile(null); setFirmaFileError(null); }}>
                                        Clear
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveIcon />}
                                        color="primary"
                                        size="small"
                                        disabled={firmaFileLoading}
                                        onClick={async () => {
                                            sumPoints();
                                            setFirmaFileLoading(true);
                                            setFirmaFileError(null);
                                            try {
                                                const canvas = sigPad.current.getCanvas();
                                                const dataUrl = canvas.toDataURL("image/png");
                                                const base64 = dataUrl.split(",")[1];
                                                const nombreArchivo = `firma_${generateUUID()}.png`;
                                                const body = {
                                                    base64: `data:image/png;base64,${base64}`,
                                                    nombreArchivo,
                                                    tipoArchivo: "image/png"
                                                };
                                                const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    body: JSON.stringify(body)
                                                });
                                                let result = null;
                                                try {
                                                    result = await response.json();
                                                } catch (jsonErr) {
                                                    setFirmaFileError("Invalid server response. CORS or network error?");
                                                    console.error("Non-JSON response:", jsonErr, response);
                                                    return;
                                                }
                                                console.log("Signature response:", result);
                                                if (result && result.success && result.url) {
                                                    setFirmaFile(result.url);
                                                    swal("Saved", "Signature saved", "success");
                                                } else {
                                                    setFirmaFileError("Could not save signature. " + (result && result.message ? result.message : "Try again."));
                                                    console.error("Error in signature response:", result);
                                                }
                                            } catch (err) {
                                                setFirmaFileError("Error uploading signature: " + (err && err.message ? err.message : err));
                                                console.error("Network error uploading signature:", err);
                                            } finally {
                                                setFirmaFileLoading(false);
                                            }
                                        }}
                                    >
                                        {firmaFileLoading ? "Saving..." : "Save"}
                                    </Button>
                                    {firmaFileError && (
                                        <Alert severity="error" sx={{ mt: 1 }}>{firmaFileError}</Alert>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>

            <Alert severity="warning" sx={{ mb: 3 }}>
                You must sign the form and save the signature before sending the information.
            </Alert>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <StyledButton
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={() => {
                        try {
                            setLoading(true);

                            // Validation: Check required fields
                            const camposRequeridos = [
                                { campo: 'nombreProveedor', valor: nombreProveedor, mensaje: 'Supplier Name' },
                                { campo: 'tipoDocumento', valor: tipoDocumento, mensaje: 'Document Type' },
                                { campo: 'numeroDocumento', valor: numeroDocumento, mensaje: 'Document Number' },
                                { campo: 'direccion', valor: direccion, mensaje: 'Address' },
                                { campo: 'correoProveedor', valor: correoProveedor, mensaje: 'Supplier Email' },
                                { campo: 'prestadorBienesServicios', valor: prestadorBienesServicios, mensaje: 'Goods/Services Provider' },
                                { campo: 'categoria', valor: categoria, mensaje: 'Category' },
                                { campo: 'evaluador', valor: evaluador, mensaje: 'Evaluator' },
                                { campo: 'cargo', valor: cargo, mensaje: 'Job Title' },
                                { campo: 'responsableVisita', valor: responsableVisita, mensaje: 'Evaluator´s Name' },
                                { campo: 'fechaEvaluacion', valor: fechaEvaluacion, mensaje: 'Evaluation Date' },
                                { campo: 'periodoEvaluado', valor: periodoEvaluado, mensaje: 'Evaluated Period' }
                            ];

                            for (let campo of camposRequeridos) {
                                if (!campo.valor || campo.valor.trim() === '') {
                                    swal({
                                        title: 'Missing Fields',
                                        text: `Please fill in: ${campo.mensaje}`,
                                        icon: 'warning',
                                    });
                                    setLoading(false);
                                    return false;
                                }
                            }

                            if (firmaFile == null) {
                                swal("Signature Required", "You must sign and save the signature before sending.", "warning");
                                setLoading(false);
                                return;
                            }

                            // Points calculation matching Visita logic
                            const currentTotalPoints = evaluations.reduce((total, e) => total + (e || 0), 0);
                            const maxPoints = evaluations.length * 3;
                            const percentageString = `${((currentTotalPoints / maxPoints) * 100).toFixed(2)}%`;

                            // Date parsing
                            const dateParts = fechaEvaluacion.split('-');
                            const year = dateParts[0];
                            const month = dateParts[1];
                            const day = dateParts[2];

                            // Construct Payload
                            const appScriptData = {
                                "codigoproveedor": codigoInternoProveedor,
                                "nombreproveedor": nombreProveedor,
                                "tipodocumento": tipoDocumento,
                                "numerodocumento": numeroDocumento,
                                "direccion": direccion,
                                "prestadorbienes": prestadorBienesServicios,
                                "evaluador": evaluador,
                                "dia": day,
                                "mes": month,
                                "ano": year,
                                "evaluacionperiodo": periodoEvaluado,
                                "correoelectronicoproveedor": correoProveedor,
                                "categoria": categoria,
                                "variablecargo": cargo,
                                "calificacion": percentageString,
                                "puntosobtenidos": currentTotalPoints.toString(),
                                "puntosposibles": maxPoints.toString(),
                                "preguntasaplicables": evaluations.length.toString(),
                                "observaciones": observacion,
                                "responsabledeevaluar": responsableVisita,
                                "firma1": firmaFile,
                            };

                            // Map all questions as 'pregunta'
                            let qNum = 1;
                            evaluationData.forEach(category => {
                                category.questions.forEach(question => {
                                    const idx = question.index;
                                    appScriptData[`pregunta${qNum}`] = evaluations[idx] ? evaluations[idx].toString() : "";
                                    qNum++;
                                });
                            });

                            const appScriptUrl = "https://script.google.com/macros/s/AKfycbwhb9aotzSq6j_dFP_07P_VgrLQmKATk88wrCU83MeSYSO1JezAoK-pAiiVVJaJs_hR/exec";

                            fetch(appScriptUrl, {
                                method: 'POST',
                                headers: {
                                    "Content-Type": "text/plain;charset=utf-8"
                                },
                                body: JSON.stringify(appScriptData)
                            })
                                .then(response => response.json())
                                .then(result => {
                                    setLoading(false);
                                    console.log("Server response:", result);

                                    swal("Success", "Evaluation sent successfully", "success");

                                    // Extraer la URL del PDF de la respuesta
                                    if (result && result.pdf && result.pdf.url) {
                                        console.log("📄 PDF URL received:", result.pdf.url);
                                        setPdfUrl(result.pdf.url);

                                        // Prepare data for generatePDF
                                        const tableDataPDF = evaluationData.map(category => ({
                                            category: category.category,
                                            questions: category.questions.map(q => ({
                                                question: q.question,
                                                evaluation: evaluations[q.index] || 0
                                            }))
                                        }));

                                        generatePDF(tableDataPDF, percentageString, firmaFile, codigoInternoProveedor, nombreProveedor, tipoDocumento, numeroDocumento, direccion, prestadorBienesServicios,
                                            evaluador, cargo, categoria, fechaEvaluacion, periodoEvaluado, correoProveedor, responsableVisita, observacion, null, responsableRecibir, false).then(base64 => {
                                                setPdfBase64(base64);
                                                setShowPdfPreview(true);
                                            }).catch(err => {
                                                console.error("Error generating local PDF:", err);
                                                setShowPdfPreview(true);
                                            });
                                    } else {
                                        console.warn("⚠️ No PDF URL received in response");
                                    }
                                })
                                .catch(e => {
                                    console.error("Error App Script:", e);
                                    setLoading(false);
                                    swal("Error", "Could not send evaluation", "error");
                                });

                        } catch (error) {
                            console.error('Error:', error.message);
                            setLoading(false);
                        }
                    }}
                    startIcon={loading ? null : <SendIcon />}
                    size="large"
                >
                    {loading ? "Sending..." : "Send information"}
                </StyledButton>
            </Box>

            {/* PDF Preview Dialog */}
            <PDFPreviewDialog
                open={showPdfPreview}
                pdfUrl={pdfUrl}
                pdfBase64={pdfBase64}
                onClose={() => setShowPdfPreview(false)}
                title="PDF Preview - Quality Evaluation"
                supplierName={nombreProveedor}
                evaluationType="Quality Evaluation"
            />

        </GlassContainer>
    );
}
